import { atom } from "jotai";
export const mobileSheetOpenAtom = atom(false);